import { render } from "./PersonView.vue?vue&type=template&id=05d9d6ff"
import script from "./PersonView.vue?vue&type=script&lang=js"
export * from "./PersonView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__